var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditPencil = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M23.1 12 11.9 23.3l-4-4L19.1 8zm.8-.7 1.7-1.7c.8-.8.8-2.1 0-2.8l-1.2-1.2c-.8-.8-2-.8-2.8 0l-1.7 1.7zM11.1 24l-.1.2-5 1 1-5 .1-.2z"
})));
export default SvgEditPencil;